import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay,numberFormat,isFunction } from '../../../../utils/utils';
import EditIcon from '@material-ui/icons/Edit';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import moment from 'moment';
import JourneyTripActionDialog from '../../../components/Trip/JourneyTripActionDialog';
import TransactionDetailsSideBar from '../../../components/RightSideBar/TransactionDetailsSideBar';
import TripTransactionDetailsCard from '../../../components/Payment/TripTransactionDetailsCard';
import DeletePartyAdvance from '../../../components/Trip/DeletePartyAdvance';
import DeleteVendorAdvance from '../../../components/Trip/DeleteVendorAdvance';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    padding:"0 24px",
    display: 'flex',
    flexDirection:'column',
    alignItems: 'center',
    backgroundColor:'#fff',
    boxShadow:'none',
    marginTop:16
  },
  box:{
    width:'100%',
    //cursor:'pointer'
  },
  listBox:{
    width:'100%',
    backgroundColor:'#f1f1f3',
    padding:'18px 24px',
    marginTop:8,
    borderRadius:8,
    paddingRight:12,
  },
  icon:{
    fontSize:24,
    color:'#03c'
  },
  listLabel:{
    fontSize:14,
    fontWeight:'normal',
    color:'#0b1323',
    marginRight:24
  },
  amount:{
    color:'#0b1323',
    fontWeight:'normal',
    fontSize:14,
    marginRight:42,
    marginLeft:24
  },
  boxAmount:{
    color:'#0b1323',
    fontWeight:'normal',
    fontSize:14,
    marginRight:8,
  },
  sep:{
    borderTop:'1px dotted rgba(107, 119, 140, 0.25)',
    flexGrow:1,
    marginTop:5
  },
  sepIcon:{
    color:'#000',
    fontSize:6,
    opacity:0.25,
    margin:'0px 7px'
  },
  date:{
    fontSize:14,
    color:'#0b1323',
    fontWeight:600
  },
  paymentMode:{
    fontSize:14,
    color:'#0b1323',
  },
  paymentData:{
    fontSize:14,
    color:'rgba(11, 19, 35, 0.75);',
  },
  add:{
    color:'#03c',
    fontWeight:600,
    fontSize:14,
    cursor:'pointer'
  }
}));
const JourneyTripSupplierAdvanceCard = (props) => {
  const {trip,journey,updateJourney} = props;
  const classes = useStyles();
  let history = useHistory();
  let vendorTransactions = journey && journey.vendorTransactions ? journey.vendorTransactions:[];
  let transactions = vendorTransactions && vendorTransactions.advance?vendorTransactions.advance:[]
  let tripDetails = trip;
  let tripId = tripDetails && tripDetails.id ? tripDetails.id:'';
  let vehicleData = journey && journey.vehicle ? journey.vehicle : {};
  let hiredTrip = journey && journey.vehicle && journey.vehicle.ownershipType && journey.vehicle.ownershipType == 'HIRED' ? true : false;
  let vendorId = hiredTrip && journey && journey.vendor && journey.vendor.vendorId ? journey.vendor.vendorId : 0;
  let tripStatus = tripDetails && tripDetails.status ? tripDetails.status : '';
  let partyBalance = tripDetails && tripDetails.balanceAmount ? tripDetails.balanceAmount : null;
  let vendorBalance = journey && journey.vendor && journey.vendor.vendorBalance ? journey.vendor.vendorBalance : null;
  let vendorSettled = hiredTrip && journey && journey.vendor && journey.vendor.isVendorSettled ? journey.vendor.isVendorSettled : false;
  //React State
  const [addOpen, setAddOpen] = useState(false);
  const [editOpen,setEditOpen] = useState(false);
  const [detailsOpen,setDetailsOpen] = useState(false);
  const [transactionData, setTransactionData] = useState({})
  const [deleteOpen, setDeleteOpen] = useState(false);

  let actionVisible = () => {
    if (hiredTrip) {
      return (tripStatus == 'PAYMENT_RECEIVED' && vendorSettled) ? false : true
    } else {
      return (tripStatus == 'PAYMENT_RECEIVED') ? false : true
    }
  }
  let editPartyAdvance = {
    action: 'edit_vendor_advance',
    label: 'Update Advance',
    confirmText: 'Update Advance',
    tabsFormat: false
  }
  const [action,setAction] = useState({
    action: 'add_advance',
    visible: actionVisible(),
    label: 'Add Advance',
    tabsFormat: true,
    eventName: 'Dweb Trip Advance Create Initiated',
    tabs: [
      {
        name: 'Party Advance',
        visible: true,
        disabled: tripStatus == 'PAYMENT_RECEIVED' ? true : false,
        person: 'party'
      },
      {
        person: 'supplier',
        visible: hiredTrip,
        disabled: vendorSettled,
        name: 'Supplier Advance'
      }
    ]
  })
  const handleActionSave = (status) => {
    /*if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }*/
  }
  const handleaddTripActionClose = (status) => {
    setAddOpen(status);
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  }
  const handleTransactionDetailsClose = () => {
    setDetailsOpen(false)
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  }
  const handleEditCashflowActionClose = (status) => {
    setEditOpen(status)
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  }
  const handleOnUpdateSuccess = (status) => {
    setEditOpen(status);
    setDetailsOpen(false)
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  }
  const onDeleteSuccess = () => {
    setDeleteOpen(false);
    setDetailsOpen(false)
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
    setTransactionData(null)
  }
  const onDeleteCancel = () => {
    setDeleteOpen(false);
    /*setTransactionData(null)
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }*/
  }
  return (
    <>
      <Paper component='div' className={classes.card} >
        <Box className={classes.box} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
            <Typography className={classes.listLabel}>(-) Advance</Typography>
            {transactions.totalAmount ?<div className={classes.sep}></div>:null}
            <Typography className={classes.amount}>{numberFormat(Math.abs(transactions&&transactions.totalAmount?transactions.totalAmount:0))}</Typography>
        </Box>
        {transactions && transactions.list && transactions.list.length>0 && <Box className={classes.listBox}>
          {transactions && transactions.list && transactions.list.map((trans,index)=>{
                return <>
                    <Box onClick={()=>{setTransactionData(trans);setDetailsOpen(true)}} className={classes.box} marginBottom={'12px'} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                      <Box display="flex" alignItems="center">
                        <Typography className={classes.date}>{moment(Number(trans.date*1000)).format("DD MMM YY")}</Typography>
                        {trans.paymentMode && <>
                          <FiberManualRecordIcon className={classes.sepIcon}/>
                          <Typography className={classes.paymentMode}>{trans.paymentMode}</Typography>
                        </>}
                        {trans.paymentData && <>
                          <FiberManualRecordIcon className={classes.sepIcon}/>
                          <Typography className={classes.paymentData}>{trans.paymentData}</Typography>
                        </>}
                      </Box>
                      <Box display="flex" alignItems="center">
                        <Typography className={classes.boxAmount}>{numberFormat(Math.abs(trans.amount))}</Typography>
                        <ChevronRightIcon className={classes.icon}/>
                      </Box>
                    </Box>
                </>
            })}
            {actionVisible() && <Box className={classes.box} marginTop={'4px'}>
              <Typography onClick={()=>{setAddOpen(true)}} className={classes.add}>Add Supplier Advance</Typography>
            </Box>}
        </Box>}
        {!transactions.list && actionVisible() && <Box className={classes.box} marginTop={'8px'}>
          <Typography onClick={()=>{setAddOpen(true)}} className={classes.add}>Add Supplier Advance</Typography>
        </Box>}
      </Paper>
      {addOpen && <JourneyTripActionDialog defaultSelected={1} defaultPerson='supplier' action={action} journey={journey} updateJourney={updateJourney} selectedTrip={trip}  partyBalance={partyBalance} vendorBalance={vendorBalance} open={addOpen} onClose={handleaddTripActionClose} onSave={handleActionSave} />}
      {editOpen && <JourneyTripActionDialog action={editPartyAdvance} journey={journey} updateJourney={updateJourney} selectedTrip={trip} editData={transactionData} open={editOpen} onClose={handleEditCashflowActionClose} onUpdateSuccess={handleOnUpdateSuccess} confirmText={editPartyAdvance.confirmText ? editPartyAdvance.confirmText : null} />}
      {deleteOpen && <DeleteVendorAdvance deleteOpen={deleteOpen} tripId={tripId} deleteId={transactionData.id} onDeleteSucees={onDeleteSuccess} onDeleteNo={onDeleteCancel} />}
      {detailsOpen && <TransactionDetailsSideBar
                rightSideBarOpen={detailsOpen}
                sideBarTitle={'Supplier Advance Details'}
                data={transactionData}
                cStyle={true}
                onEdit={(!transactionData || vendorSettled || (transactionData && !transactionData.id) || (transactionData && transactionData.isBrokerEnabled)) ? null : (data) => {
                  setEditOpen(true)
                }}
                onDelete={(!transactionData || vendorSettled || (transactionData && !transactionData.id) || (transactionData && transactionData.isBrokerEnabled)) ? null : (data) => {
                   setDeleteOpen(true)
                }}
                //sideBarSecondaryTitle={null}
                handleSubmit={event => { }}
                toggleRightSideBar={handleTransactionDetailsClose}
            >
                <TripTransactionDetailsCard
                    journey={journey} 
                    updateJourney={updateJourney} 
                    trip={trip}
                    data={transactionData}
                    type={transactionData && transactionData.entityType ? transactionData.entityType : null}
                />
            </TransactionDetailsSideBar>}
    </>
  );
}
export default JourneyTripSupplierAdvanceCard;